module.exports = __webpack_public_path__ + "img/uploadback.67230987.svg";